import React from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';
import {
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Portlet, PortletContent } from '../../../../../components';
import { PendenciasTableRowStyles } from '../Pendencias.style';
import { PendenciasTableRow } from './PendenciasTableRow';
import PendenciasParametrosTablePagination from './PendenciasParametrosTablePagination';
import TableColumnSortButton from '../../../../../theme/components/TableColumnSortButton/TableColumnSortButton';

const useStyles = makeStyles(PendenciasTableRowStyles);

export default function PendenciasParametrosTable(props) {
  const classes = useStyles();
  const {
    data,
    total,
    currentPage,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    setSorts,
    sorts,
    onVerDetalhes,
  } = props;

  return (
    <Portlet className={cls(classes.root)} style={{ width: '100%' }}>
      <PortletContent noPadding style={{ width: '100%' }}>
        <Table style={{ width: '100%', tableLayout: 'fixed' }}>
          <TableHead>
            <TableRow>
              <TableCell width="40%">
                <Typography variant="body2">
                  Parceiro
                  <TableColumnSortButton
                    value={sorts?.parceiro || ''}
                    onChange={sort => setSorts({ parceiro: sort, updatedAt: null })}
                  />
                </Typography>
              </TableCell>
              <TableCell width="20%">
                <Typography variant="body2">Status</Typography>
              </TableCell>
              <TableCell width="10%">
                <Typography variant="body2">Serviço</Typography>
              </TableCell>
              <TableCell width="20%">
                <Typography variant="body2">
                  Última Atualização
                  <TableColumnSortButton
                    value={sorts?.updatedAt || ''}
                    onChange={sort => setSorts({ updatedAt: sort, parceiro: null })}
                  />
                </Typography>
              </TableCell>
              <TableCell width="10%" align="right">
                <Typography variant="body2">Ações</Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map(row => (
              <PendenciasTableRow key={row.partnerId} rowData={row} onVerDetalhes={onVerDetalhes} />
            ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                count={total}
                page={currentPage - 1}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage="Registros por página"
                onPageChange={() => {}}
                ActionsComponent={() => (
                  <PendenciasParametrosTablePagination
                    total={total}
                    onChangePage={handleChangePage}
                    page={currentPage}
                    rowsPerPage={rowsPerPage}
                  />
                )}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </PortletContent>
    </Portlet>
  );
}

PendenciasParametrosTable.propTypes = {
  data: PropTypes.array.isRequired,
  total: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  handleChangePage: PropTypes.func.isRequired,
  handleChangeRowsPerPage: PropTypes.func.isRequired,
  setSorts: PropTypes.func.isRequired,
  sorts: PropTypes.object.isRequired,
  onVerDetalhes: PropTypes.func.isRequired,
};
